"use strict";

exports.__esModule = true;
exports.default = void 0;
var _appendSlide = _interopRequireDefault(require("./appendSlide"));
var _prependSlide = _interopRequireDefault(require("./prependSlide"));
var _addSlide = _interopRequireDefault(require("./addSlide"));
var _removeSlide = _interopRequireDefault(require("./removeSlide"));
var _removeAllSlides = _interopRequireDefault(require("./removeAllSlides"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _default = {
  appendSlide: _appendSlide.default,
  prependSlide: _prependSlide.default,
  addSlide: _addSlide.default,
  removeSlide: _removeSlide.default,
  removeAllSlides: _removeAllSlides.default
};
exports.default = _default;